import { IApiError } from '@/models/apiError.model';
import { IInterLinksImportResponse, IInterLink } from '@/models/linkingTool.model';
import { IPaginationResponse } from '@/models/pagination.model';

export const SLICE_NAME = 'interLinks';

export interface InterLinksState {
  interLink: IInterLink[] | null;
  pagination: IPaginationResponse | null;
  importResult: IInterLinksImportResponse | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: InterLinksState = {
  interLink: null,
  pagination: null,
  importResult: null,
  isLoading: false,
  error: null,
};
